import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { navTabs } from "@/components/BottomNav";

// Swipe left/right anywhere on a tab page to move to the next/previous bottom tab.
function inHorizontalScroller(el) {
  for (let n = el; n && n !== document.body; n = n.parentElement) {
    if (["INPUT", "TEXTAREA", "SELECT"].includes(n.tagName)) return true;
    if (n.closest?.("[role=dialog]")) return true;
    const ox = getComputedStyle(n).overflowX;
    if ((ox === "auto" || ox === "scroll") && n.scrollWidth > n.clientWidth) return true;
  }
  return false;
}

export default function SwipeNav({ children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const path = useRef(pathname);
  path.current = pathname;

  useEffect(() => {
    let s = null;
    let last = null;
    const start = (e) => {
      const t = e.touches[0];
      s = e.touches.length === 1 && !inHorizontalScroller(e.target) ? { x: t.clientX, y: t.clientY, at: Date.now() } : null;
      last = s;
    };
    const move = (e) => {
      if (s) last = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    };
    // WKWebView often fires touchcancel instead of touchend for horizontal pans.
    const end = (e) => {
      if (!s) return;
      const t = e.changedTouches?.[0];
      const p = t ? { x: t.clientX, y: t.clientY } : last;
      const dx = p.x - s.x;
      const dy = p.y - s.y;
      const quick = Date.now() - s.at < 800;
      s = null;
      if (!quick || Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      const tabs = navTabs();
      const i = tabs.findIndex((tab) => path.current.startsWith(tab.to));
      const next = i >= 0 && tabs[i + (dx < 0 ? 1 : -1)];
      if (next) navigate(next.to);
    };
    const opts = { passive: true };
    document.addEventListener("touchstart", start, opts);
    document.addEventListener("touchmove", move, opts);
    document.addEventListener("touchend", end, opts);
    document.addEventListener("touchcancel", end, opts);
    return () => {
      document.removeEventListener("touchstart", start);
      document.removeEventListener("touchmove", move);
      document.removeEventListener("touchend", end);
      document.removeEventListener("touchcancel", end);
    };
  }, [navigate]);

  return <div data-testid="swipe-nav">{children}</div>;
}
